import { render, staticRenderFns } from "./withdrawRecord.vue?vue&type=template&id=ee28a426&scoped=true&"
import script from "./withdrawRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawRecord.vue?vue&type=style&index=0&id=ee28a426&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee28a426",
  null
  
)

export default component.exports